import { render, staticRenderFns } from "./zhjy.vue?vue&type=template&id=cf81ce54&scoped=true&"
import script from "./zhjy.vue?vue&type=script&lang=js&"
export * from "./zhjy.vue?vue&type=script&lang=js&"
import style0 from "./zhjy.vue?vue&type=style&index=0&id=cf81ce54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf81ce54",
  null
  
)

export default component.exports